import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';



export class ProjectSelect extends Component {

    render() {
        const { projects, title, onchange } = this.props
        return (
            <Card>
                <CardHeader title={title} className="romis-card-header"></CardHeader>
                <CardContent>
                    <Autocomplete
                        options={projects}
                        getOptionLabel={option => option.ProjectTitle}
                        autoComplete
                        includeInputInList
                        onChange={onchange}
                        renderInput={params => (
                            <TextField {...params} label="Projects" margin="normal" fullWidth />
                        )}
                    />
                </CardContent>
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ProjectSelect.js